module.exports = __webpack_public_path__ + "static/media/vorxis-1.4c1a1059.jpg";